import React, { ReactNode } from "react"
import { Box, Flex } from "@chakra-ui/react"
import { PREVIEW_PADDING } from "../PreviewFrameWithBranding/PreviewFrameWithBranding"

type Props = {
  children: ReactNode
}
const PreviewCard = ({ children }: Props) => (
  <Box px={PREVIEW_PADDING}>
    <Flex
      borderLeftWidth={1}
      borderRightWidth={1}
      backgroundColor="white"
    >{children}
    </Flex>
  </Box>
)

export default PreviewCard
